import { gql } from '@apollo/client';

export default gql`
  mutation SendQuoteConfirmationEmail($bookingReference: String!, $emailAddress: String!, $market: String, $quoteType: String) {
    sendQuoteConfirmationEmail(bookingReference: $bookingReference, emailAddress: $emailAddress, market: $market, quoteType: $quoteType)
  }
`;
